export type CalculateVenueEss = {
  structure: CalculateVenueStructureEss;
  dates: CalculateVenueDatesEss;
  global: CalculateVenueGlobalEss;
};

export type CalculateVenueGlobalEss = {
  score: number;
  maxScore: number;
  scoreLetter: string;
};

export type CalculateVenueStructureEss = {
  scoreLetter: string;
  score: number;
  maxScore: number;
  topics: {
    PARITY_EQUALITY: {
      score: number;
      maxScore: number;
      sections: {
        ARTISTIC_TEAM: { score: number; maxScore: number };
        PERMANENT_OPERATIONAL_TEAM: { score: number; maxScore: number };
        OCCASIONAL_OPERATIONAL_TEAM: { score: number; maxScore: number };
        TRANSPARENCY_MANAGEMENT: { score: number; maxScore: number };
      };
    };
    ACCESSIBILITY_SOCIAL_DIALOGUE: {
      score: number;
      maxScore: number;
      sections: {
        ACCESSIBILITY: { score: number; maxScore: number };
        RISK_PREVENTION: { score: number; maxScore: number };
        COMMUNICATION: { score: number; maxScore: number };
        TEAM_MANAGEMENT: { score: number; maxScore: number };
      };
    };
    LOCAL_IMPACT_RSE_ENGAGEMENT: {
      score: number;
      maxScore: number;
      sections: {
        LOCALITY_EMPLOYMENT_PARTNERS: { score: number; maxScore: number };
        ECONOMIC_SOCIAL_IMPACT: { score: number; maxScore: number };
      };
    };
  };
};

export type CalculateVenueDatesEss = {
  score: number;
  maxScore: number;
  scoreLetter: string;
};

export const EMPTY_CALCULATE_VENUE_ESS: CalculateVenueEss = {
  global: {
    score: 0,
    maxScore: 0,
    scoreLetter: '-',
  },
  structure: {
    scoreLetter: '-',
    score: 0,
    maxScore: 0,
    topics: {
      PARITY_EQUALITY: {
        score: 0,
        maxScore: 0,
        sections: {
          ARTISTIC_TEAM: { score: 0, maxScore: 0 },
          PERMANENT_OPERATIONAL_TEAM: { score: 0, maxScore: 0 },
          OCCASIONAL_OPERATIONAL_TEAM: { score: 0, maxScore: 0 },
          TRANSPARENCY_MANAGEMENT: { score: 0, maxScore: 0 },
        },
      },
      ACCESSIBILITY_SOCIAL_DIALOGUE: {
        score: 0,
        maxScore: 0,
        sections: {
          ACCESSIBILITY: { score: 0, maxScore: 0 },
          RISK_PREVENTION: { score: 0, maxScore: 0 },
          COMMUNICATION: { score: 0, maxScore: 0 },
          TEAM_MANAGEMENT: { score: 0, maxScore: 0 },
        },
      },
      LOCAL_IMPACT_RSE_ENGAGEMENT: {
        score: 0,
        maxScore: 0,
        sections: {
          LOCALITY_EMPLOYMENT_PARTNERS: { score: 0, maxScore: 0 },
          ECONOMIC_SOCIAL_IMPACT: { score: 0, maxScore: 0 },
        },
      },
    },
  },
  dates: {
    score: 0,
    maxScore: 0,
    scoreLetter: '-',
  },
};
